function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.375 0C1.52051 0 0 1.52051 0 3.375V9H27V3.375C27 1.52051 25.4795 0 23.625 0H3.375ZM3.375 2.25H23.625C24.2578 2.25 24.75 2.74219 24.75 3.375V6.75H2.25V3.375C2.25 2.74219 2.74219 2.25 3.375 2.25ZM0 11.25V24C0 25.6569 1.34315 27 3 27H15.75V11.25H0ZM18 11.25V27H24C25.6569 27 27 25.6569 27 24V11.25H18ZM2.25 13.5H13.5V24.75H4.25C3.14543 24.75 2.25 23.8546 2.25 22.75V13.5ZM20.25 13.5H24.75V22.75C24.75 23.8546 23.8546 24.75 22.75 24.75H20.25V13.5Z",
  fill: "#FEAA2C"
});

const SvgFm = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgFm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FM.d05ff89c.svg";
export { ForwardRef as ReactComponent };